var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignmentJustified = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.19328C3 4.81039 3.31039 4.5 3.69328 4.5H20.3067C20.6896 4.5 21 4.81039 21 5.19328V5.19328C21 5.57616 20.6896 5.88655 20.3067 5.88655H3.69328C3.31039 5.88655 3 5.57616 3 5.19328V5.19328ZM3 9.74052C3 9.32407 3.33667 8.98598 3.75312 8.98423L20.2405 8.91496C20.6595 8.9132 21 9.25231 21 9.67124V9.67124C21 10.0877 20.6633 10.4258 20.2469 10.4275L3.75947 10.4968C3.34054 10.4986 3 10.1595 3 9.74052V9.74052ZM3 14.2059C3 13.7882 3.33861 13.4496 3.7563 13.4496H20.2437C20.6614 13.4496 21 13.7882 21 14.2059V14.2059C21 14.6236 20.6614 14.9622 20.2437 14.9622H3.7563C3.33861 14.9622 3 14.6236 3 14.2059V14.2059ZM3 18.7558C3 18.3383 3.33829 17.9998 3.75577 17.9995L20.2432 17.9879C20.6611 17.9876 21 18.3263 21 18.7442V18.7442C21 19.1617 20.6617 19.5002 20.2442 19.5005L3.75683 19.5121C3.33893 19.5124 3 19.1737 3 18.7558V18.7558Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignmentJustified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alignment-justified.3640cc56d2795ed2a3b548b9a00978f9.svg";